<h1 mat-dialog-title>{{ 'page.items.escalation.escalate' | translate }}</h1>

<mat-dialog-content>
  <mat-tree #tree [dataSource]="boards" [childrenAccessor]="childrenAccessor">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <div class="d-flex justify-content-between w-100">
        <ng-container *ngTemplateOutlet="radioButtonTemplate; context: { node: node }"></ng-container>
      </div>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <div class="d-flex justify-content-between w-100">
        <ng-container *ngTemplateOutlet="radioButtonTemplate; context: { node: node }"></ng-container>
      </div>
    </mat-tree-node>
  </mat-tree>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton="tonal" mat-dialog-close (click)="closeDialog()">{{ 'button.cancel' | translate }}</button>
  <button mat-flat-button type="submit" (click)="onSubmit()">{{ 'page.items.escalation.escalate' | translate }}</button>
</mat-dialog-actions>

<ng-template #radioButtonTemplate let-node="node">
  <mat-radio-group [(ngModel)]="escalatedBoardId">
    <mat-radio-button [disabled]="node.isCurrent" [value]="node.id" class="w-100">
      {{ node.name }}
      <ng-container *ngIf="item?.escalatedBoardId === node.id">
        <ng-template [ngTemplateOutlet]="escalatedTag"></ng-template>
      </ng-container>
      <ng-container *ngIf="item?.boardId === node.id">
        <ng-template [ngTemplateOutlet]="currentBoardTag"></ng-template>
      </ng-container>
    </mat-radio-button>
  </mat-radio-group>
</ng-template>

<ng-template #escalatedTag>
  <mat-chip class="tag-chip" disableRipple>
    <div class="d-flex align-items-center">
      <mat-icon class="escalated-board-icon me-2">arrow_upward</mat-icon>
      <span class="f-10">{{ 'page.items.escalation.escalatedTo' | translate }}</span>
    </div>
  </mat-chip>
</ng-template>

<ng-template #currentBoardTag>
  <mat-chip class="tag-chip" disableRipple>
    <div class="d-flex align-items-center">
      <span class="f-10">{{ 'page.items.escalation.mainBoard' | translate }}</span>
    </div>
  </mat-chip>
</ng-template>
